import React, { useEffect, ReactNode } from 'react'
import { matchShortcut } from './platform'

// Define the Shortcut interface
export interface Shortcut {
  id: string
  code: string
  shiftKey: boolean
  // ctrlKey means the primary modifier: Ctrl on non-mac, Cmd on mac
  ctrlKey: boolean
}

// Define the props for KeyboardProvider
interface KeyboardProviderProps {
  enabled: boolean
  keys: Shortcut[]
  onPress: (shortcut: Shortcut) => void
  children: ReactNode
}

export const KeyboardProvider: React.FC<KeyboardProviderProps> = ({
  enabled,
  keys,
  onPress,
  children
}) => {
  useEffect(() => {
    if (!enabled) return

    const handleKeyDown = (event: KeyboardEvent) => {
      // Find if the pressed key matches any of the shortcuts
      const matchedShortcut = matchShortcut(keys, event)
      
      if (matchedShortcut) {
        onPress(matchedShortcut)
      }
    }

    // Add event listener to document
    document.addEventListener('keydown', handleKeyDown)

    // Cleanup function to remove event listener
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [enabled, keys, onPress])

  return <>{children}</>
}
